import { Modal, Box } from "@mui/material";

import { getBatchFullName } from "./helpers";
import UploadBatchCsv from "./UploadBatchCsv";


const UploadModal = ({ openUploadCsv, setOpenUploadCsv, batches }) => {
  const selectedBatch = batches.find((b) => b.id === openUploadCsv);
  console.log("selected Batch", selectedBatch)

  return (
    <Modal
      open={!!openUploadCsv}
      onClose={() => setOpenUploadCsv(null)}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          maxWidth: 600,
          width: "90%",
          bgcolor: "background.paper",
          p: 2,
          borderRadius: 2,
        }}
      >
        {selectedBatch && (
          <UploadBatchCsv 
  batch={selectedBatch}
  onSuccess={() => setOpenUploadCsv(null)} 
/>

        )}
      </Box>
    </Modal>
  );
};

export default UploadModal;
